import { Flex, FlexProps } from '@mantine/core';
import styled from 'styled-components';

export const BadgeContainer = styled(Flex)<FlexProps>`
	background-color: ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 1rem;
	padding: 0.25rem 0.5rem;

	height: 1.5rem;
	min-height: 1.5rem;
	max-height: 1.5rem;
`;
